/**
 * * Use IdleQueueService service to make sure these resources are loaded during idle time or at the earliest when they are needed
 * Ref: https://philipwalton.com/articles/idle-until-urgent/
 */
// @ts-expect-error: Declaration not found error

import { IdleQueue } from 'idlize/IdleQueue.mjs';
import { isServer } from '~/utils/EnvUtils';

interface IdleQueueService {
  addTask(task: () => void): void,
  addBgTask(task: () => void): void,
}

class ClientIdleQueueService implements IdleQueueService {
  private queue: any;
  private bgQueue: any;

  constructor() {
    this.queue = new IdleQueue({ ensureTasksRun: true });
    this.bgQueue = new IdleQueue();
  }

  public addTask(task: () => void) {
    this.queue.pushTask(() => {
      task();
    });
  }

  public addBgTask(task: () => void) {
    this.bgQueue.pushTask(() => {
      task();
    });
  }
}

class ServerIdleQueueService implements IdleQueueService {
  public addTask() {}
  public addBgTask() {}
};

export default isServer() ? new ServerIdleQueueService() : new ClientIdleQueueService();
